import { render, staticRenderFns } from "./teachClass.vue?vue&type=template&id=8eb1bf7c&scoped=true"
import script from "./teachClass.vue?vue&type=script&lang=js"
export * from "./teachClass.vue?vue&type=script&lang=js"
import style0 from "./teachClass.vue?vue&type=style&index=0&id=8eb1bf7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb1bf7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eb1bf7c')) {
      api.createRecord('8eb1bf7c', component.options)
    } else {
      api.reload('8eb1bf7c', component.options)
    }
    module.hot.accept("./teachClass.vue?vue&type=template&id=8eb1bf7c&scoped=true", function () {
      api.rerender('8eb1bf7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/teachClass.vue"
export default component.exports